






























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import Delete from './delete.vue'
import { setApply } from '@/utils/cookies'
// api
import { deletes, detail, getAllList } from '@/pages/adhibition/api/index'
@Component({
  name: 'Dialog',
  components: {
      Delete
  }
})
export default class extends Vue {
  @Prop() private isMoreVisible!: any
  private texNum: number = 0
  private isDisable: boolean = false
  private el: any = this.$refs
  private dataTable =[]
  private baseData= {}
  private searchData = {
    name: ''
  } as any
  private dialog = {
    id: '',
    status: false,
    title: '',
    msg: '',
    isVisible: false,
    isDeleVisible: false
  } as any
  // 功能函数
  created() {
      this.getList()
  }
  // 获取数据
  private async getList() {
    const { data } = await getAllList(this.searchData)
    if (data.isSuccess === true) {
      this.dataTable = data.data
    }
  }
  // 修改
  private handleChange(val:any) {
    setApply(JSON.stringify(val))
    location.reload()
  }
  // 删除
  private async deleteButton() {
    const ids: any[] = [this.dialog.id]
    const { data } = await deletes({ ids: ids })
    if (data.isSuccess === true) {
      this.$message.success('操作成功')
    } else {
      // this.$message.error(data.msg)
    }
    this.getList()
    this.dialog.isDeleVisible = false
  }
  // 删除
  private handleDelete(row: any) {
    this.dialog.id = row.id
    this.dialog.name = row.name
    this.dialog.isDeleVisible = true
  }
  // ui
  handleCloseDelete() {
    this.dialog.isDeleVisible = false
  }
  // 搜索
  private handleSearch() {
    this.getList()
  }
  // 重置
  resetSearch() {
    (this.$refs.ruleForm as ElForm).resetFields()
    this.getList()
  }
  // 表单取消
  private handleClose() {
    this.dialog.isVisible = false
  }
  private handleMoreClose() {
      this.$emit('close')
  }
}
